import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication/authentication.service';
import {UserStatus} from '../entities/user/user.entity';

@Injectable({
  providedIn: 'root'
})
export class RegistrationDoneGuard implements CanActivate {
  constructor(
    private readonly router: Router,
    private readonly authenticationService: AuthenticationService,
  ) {}

  canActivate(): boolean {
    const user = this.authenticationService.getCurrentUser();
    if (user && user.status === UserStatus.registered) {
      return true;
    } else {
      this.router.navigate(['/register']);
      return false;
    }
  }
}
